// extracted by mini-css-extract-plugin
export default {"rightContent":"index_rightContent_Wpnxq","list":"index_list_NfnRn","title":"index_title_5MFCq","ad_box":"index_ad_box_pmp-y"};